import { TFunction } from 'next-i18next'

export const getGoldBarInCartErrorMessage = (t: TFunction) => {
  return t('limit_1_per_customer_per_year')
}
export const GOLD_BAR_SUBCLASS = 1499
